import { ITaskFolderFilterState } from '../../../shared/component/filter/task-folder-filter/task-folder-filter.model';
import { ActionTypes, TaskFolderActions } from './task-folder.actions';

export const initialState: ITaskFolderFilterState = {
  getTaskFoldersLoading: false,
  getTaskFoldersLoaded: false,
  taskFolderData: null,
};

export function taskFolderFilterReducer(
  state: ITaskFolderFilterState = initialState,
  action: TaskFolderActions,
): ITaskFolderFilterState {
  switch (action.type) {
    case ActionTypes.GetTaskFolders:
      return { ...state, getTaskFoldersLoading: true, getTaskFoldersLoaded: false };
    case ActionTypes.GetTaskFoldersLoaded:
      return {
        ...state,
        getTaskFoldersLoading: false,
        getTaskFoldersLoaded: true,
        taskFolderData: action.response,
      };
    case ActionTypes.FetchError:
      return initialState;
    case ActionTypes.ResetStore:
      return initialState;
  }
}
